import { render, staticRenderFns } from "./part_inventory.vue?vue&type=template&id=28733e28&scoped=true"
import script from "./part_inventory.vue?vue&type=script&lang=js"
export * from "./part_inventory.vue?vue&type=script&lang=js"
import style0 from "./part_inventory.vue?vue&type=style&index=0&id=28733e28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28733e28",
  null
  
)

export default component.exports